<template>
  <div class="shipmentInformation table-responsive col-12">
    <li
      style="
        display: block;
        color: #000000;
        font-family: dfyuanstd-w5, dfyuanstd-w3;
        font-size: 1rem;
      "
    >
      發料資訊
    </li>
    <b-table
      :items="shipmentInformationItem"
      :fields="shipmentInformationFields"
      class="text-center shipmentInformation-table-detail"
    >
      <template #thead-top="">
        <b-tr>
          <b-th class="font-family-dfyuanstd-w5 table-col-hight"><div>包裝作業單號</div></b-th>
          <b-th class="font-family-dfyuanstd-w5 table-col-hight"><div>包裝工令單號</div></b-th>
          <b-th class="font-family-dfyuanstd-w5 table-col-hight"><div>包裝編號</div></b-th>
          <b-th class="font-family-dfyuanstd-w5 table-col-hight"><div>包裝方式</div></b-th>
          <b-th colspan="2" class="font-family-dfyuanstd-w5 table-col-hight"><div>發料批號</div></b-th>
          <b-th class="font-family-dfyuanstd-w5 table-col-hight"><div>嘜頭</div></b-th>
        </b-tr>
      </template>
      <template #cell(shipment_data)="{ item }">
        <template v-if="item.shipment_data.length == 0">
          <div>-</div>
        </template>
        <template v-else>
          <div
            v-for="(item_data_data, item_data_index) in item.shipment_data"
            :key="item_data_index"
          >
            {{ item_data_data }}
          </div>
        </template>
      </template>
      <!-- <template #cell(shipment_item)="{ item }">
        <b-row
          v-for="(item_data, index) in item.shipment_item"
          :key="index"
          class="mx-0 py-0"
        >
          <b-col style="min-width: 78px; max-width: 78px">
            {{ item.shipment_item[index].name }}
          </b-col>
          <b-col style="border-left: 1px solid #999999">
            <template v-if="item.shipment_item[index].data != undefined">
              <template v-if="item.shipment_item[index].data.length == 0">
                <div>-</div>
              </template>
              <template v-else>
                <div
                  v-for="(item_data_data, item_data_index) in item
                    .shipment_item[index].data"
                  :key="item_data_index"
                >
                  {{ item_data_data }}
                </div>
              </template>
            </template>
          </b-col>
        </b-row>
      </template> -->
    </b-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "shipmentInformation",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      shipmentInformationFields:
        "shipmentInformation/get_shipmentInformationFields",
      shipmentInformationItem: "shipmentInformation/get_shipmentInformationItem"
    })
  }
};
</script>

<style lang="scss">
.shipmentInformation-table-detail thead th {
  border-top: 1px solid;
}
.shipmentInformation-table-detail th,
.shipmentInformation-table-detail td {
  font-size: 1rem;
  min-width: 65px;
  padding: 0.1rem;
  border-color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  background-color: #ffffff;
  vertical-align: middle !important;
}
.shipmentInformation-table-detail th:first-child,
.shipmentInformation-table-detail td:first-child {
  border-left: 1px solid;
}
.shipmentInformation-table-detail {
  margin-bottom: 0px;
}
.shipmentInformation-table-detail thead th {
  color: #000000 !important;
  background-color: #cccccc !important;
}
.shipmentInformation-table-detail thead tr:nth-child(2) {
  display: none;
}
.shipmentInformation-table-detail thead tr:last-child th:nth-child(5) {
  min-width: 28rem;
}
.shipmentInformation-table-detail > tbody > tr > td:nth-child(5) {
  padding: 0;
}
.shipmentInformation-table-detail > tbody > tr > td:nth-child(5) > div {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.75rem 0;
}
.shipmentInformation-table-detail
  > tbody
  > tr
  > td:nth-child(5)
  > div:nth-child(1) {
  border-bottom: 1px solid #999999;
}
</style>



// WEBPACK FOOTER //
// src/components/shipmentInformation.vue